import React from 'react';
import PropTypes from 'prop-types';

import '../styles/InputMenu.css';
import MenuHeader from './MenuHeader';

const InputMenu = ({ name, parentName, title, question, index }) => {
    const inputClass = index === 0 ? 'Set-button Button-active' : 'Set-button';
    const okClass = index === 1 ? 'Set-button Button-active' : 'Set-button';
    return (
      <>
        <MenuHeader itemName={name} parentItemName={parentName} />
        <div className="Input-main-screen">
          <div className="Input-title">{title}</div>
          <div className="Input-question">{question}</div>
          <div className={inputClass}>Input</div>
          <div className={okClass}>OK</div>
        </div>
      </>
    );
};
  
InputMenu.propTypes = {
    name: PropTypes.string.isRequired,
    parentName: PropTypes.string,
    title: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
};

export default InputMenu;